import { EmptyResourceState } from "@/components/custom/resources/empty-resource-state";
import { GatewaysEmptyHero } from "./gateways-empty-hero";

type GatewaysEmptyStateProps = {
  /** True when gateways exist but none match the active search. */
  isFiltered: boolean;
  /** Navigates to the dedicated gateway create page. */
  onCreate: () => void;
};

export const GatewaysEmptyState = ({
  isFiltered,
  onCreate,
}: GatewaysEmptyStateProps) => {
  if (isFiltered) {
    return (
      <EmptyResourceState
        description="No gateways match your search criteria."
        resourceType="matching MCP gateways"
      />
    );
  }

  return <GatewaysEmptyHero onCreate={onCreate} />;
};
